export default {
  title: 'Heading.RobloxBadge',
  seeMoreLabel: 'Action.SeeMore',
  seeLessLabel: 'Action.SeeLess',
  thresholdNumShowSeeMoreLabel: 6
};
